"use client";

import { age } from "@/lib/format";
import { useUi } from "@/components/ui/use-ui";

/** Relative age ("4d") computed in the client, so server prerendering never reads the clock. */
export function TimeAgo({ iso }: { iso: string }) {
  const t = useUi();
  return (
    <time dateTime={iso} suppressHydrationWarning>
      {age(iso, t.ago)}
    </time>
  );
}
